import React from 'react';
import { CTAButton } from './CTAButton';
export function MechanismSection() {
  return <section className="bg-primary-emerald py-[100px] px-5" data-id="element-347">
      <div className="max-w-[820px] mx-auto" data-id="element-348">
        <div className="text-center mb-16 max-w-[700px] mx-auto" data-id="element-349">
          <h2 className="font-serif text-[36px] md:text-[52px] text-cream-light leading-tight mb-2" data-id="element-350">
            You Are Not Bad With Money.
          </h2>
          <p className="font-serif text-[28px] md:text-[36px] italic text-gold-accent" data-id="element-351">
            You Just Never Had The Right Tools.
          </p>
        </div>

        <div className="w-full overflow-x-auto mb-16" data-id="element-352">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-353">
            <thead data-id="element-354">
              <tr data-id="element-355">
                <th className="pb-6 w-1/2 font-sans font-bold text-[16px] text-blood-red uppercase tracking-wider border-b border-gold-accent/15" data-id="element-356">
                  WHAT YOU'VE TRIED
                </th>
                <th className="pb-6 w-1/2 font-sans font-bold text-[16px] text-gold-accent uppercase tracking-wider border-b border-gold-accent/15 pl-6" data-id="element-357">
                  WHAT THIS IS
                </th>
              </tr>
            </thead>
            <tbody className="font-sans text-[16px]" data-id="element-358">
              {[['Generic budgeting apps', 'Pre-built worksheet you fill in'], ['Motivational debt books', 'Word-for-word scripts you read out loud'], ['YouTube finance videos', '19 tools with exact instructions'], ['Spreadsheets you abandoned', '15-minute weekly ritual that sticks'], ["Advice to 'cut expenses'", "A system that finds $200–$500 you're losing"], ['Willpower', 'Automation that works while you sleep']].map((row, i) => <tr key={i} data-id="element-359">
                  <td className="py-5 text-cream-light/70 border-b border-gold-accent/15 pr-4" data-id="element-360">
                    {row[0]}
                  </td>
                  <td className="py-5 text-gold-accent font-bold border-b border-gold-accent/15 pl-6" data-id="element-361">
                    {row[1]}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center" data-id="element-362">
          <p className="font-serif text-[22px] md:text-[26px] italic text-cream-light leading-relaxed" data-id="element-363">
            There is a difference between knowing what to do
            <br data-id="element-364" />
            and having a system that does it for you.
            <br data-id="element-365" />
            <span className="font-bold text-gold-accent not-italic mt-2 block" data-id="element-366">
              This is the system.
            </span>
          </p>

          <div className="mt-12" data-id="element-367">
            <CTAButton subText="19 tools · 7 scripts · 15 minutes a week" data-id="element-368">
              I WANT THE RIGHT TOOLS — $9.99
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}